export enum CONTROL_EVENT {
  TO_LOGIN,
  TO_OPEN_PICKUP,
  TO_OPEN_ADDRESS,
  TO_VALID_PRODUCT,
  ON_RELOAD_PRODUCT
}
